import type { WallCatalogSettings } from "building-types/settings/wallCatalogSettings";
import type { WallAssemblyStructuralLayer } from "building-types/walls/wallAssemblyTypes";
import { nameFromWallMaterialId } from "building-types/walls/wallCatalogQuery";
import { worldInchesNew } from "common/utils/nominalNumbers";

/**
 * Attempt to create a name for a wall assembly from constituent layers.
 */
export function wallStructuralAssemblyName(layers: WallAssemblyStructuralLayer[], wallCatalog: WallCatalogSettings) {
  return layers.map((layer) => nameFromWallMaterialId(wallCatalog, layer["wallMaterialId"])).join(", ");
}

export function wallStructuralAssemblyThickness(
  layers: WallAssemblyStructuralLayer[],
  wallCatalog: WallCatalogSettings,
) {
  const thickness = layers.reduce((acc, layer) => {
    const material = wallCatalog.wallMaterials[layer.wallMaterialId];
    if (material) {
      return acc + material.thickness;
    }
    return acc;
  }, 0);
  return worldInchesNew(thickness);
}
